import { useUser } from '../../../../../redux/reducer/user';
import { useContent, useWishes } from '../../../../../redux/reducer/content';

export default function useGetItems() {
  const { profile: { items } = {} } = useUser();
  const { notFilteredShopItems } = useContent();
  const {
    donatedWishes: { list: wishesList },
  } = useWishes();

  return {
    wishes: wishesList?.map?.((wishData) => ({ ...wishData, type: 'wish' })) ?? [],
    clothes:
      items?.reduce?.((acc, clothData) => {
        if (clothData.is_gift) {
          const { preview_image } = notFilteredShopItems?.find?.(({ id }) => id === clothData?.id) ?? {};
          acc.push({ ...clothData, preview_image, type: 'cloth' });
        }
        return acc;
      }, []) ?? [],
  };
}
